/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface BlockKitContext
 */
export interface BlockKitContext {
    /**
     * 
     * @type {string}
     * @memberof BlockKitContext
     */
    productId?: string;
    /**
     * 
     * @type {number}
     * @memberof BlockKitContext
     */
    guidanceId?: number;
}

/**
 * Check if a given object implements the BlockKitContext interface.
 */
export function instanceOfBlockKitContext(value: object): boolean {
    return true;
}

export function BlockKitContextFromJSON(json: any): BlockKitContext {
    return BlockKitContextFromJSONTyped(json, false);
}

export function BlockKitContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockKitContext {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'] == null ? undefined : json['productId'],
        'guidanceId': json['guidanceId'] == null ? undefined : json['guidanceId'],
    };
}

export function BlockKitContextToJSON(value?: BlockKitContext | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'productId': value['productId'],
        'guidanceId': value['guidanceId'],
    };
}

